import { isEmpty } from 'lodash'

import createComputed from 'modules/core/hooks/createComputed'
import { matchText } from 'modules/core/lib/stringUtils'
import { employeeUser } from 'modules/core/store/collections/users'

import type Employee from 'modules/employees/store/models/Employee'

export const useSearchEmployees = createComputed((search: string, employees: Employee[]) => {
  if (isEmpty(search)) return employees

  return employees.filter((employee) => {
    const user = employeeUser(employee)

    return user && matchText(search, user.fullName())
  })
})
